import { useQuery } from "@tanstack/react-query";
import { AreaByScopeOfWork } from "../types/scope-of-work.interface";
import { TSquareFootage } from "../types/square-footage";
import { getSales } from "../actions/getSales";

interface TypeOfService {
  costBias: number;
  baseRatePerHour: number;
}

export interface SalesResponse {
  mainAreas: {
    areas: any[];
    cost: number;
    time: {
      minutes: number;
      formatted: string;
    };
  };
  otherAreas: {
    areas: any[];
    cost: number;
    time: {
      minutes: number;
      formatted: string;
    };
  };
  additionalObjects: {
    cost: number;
    time: {
      minutes: number;
      formatted: string;
    };
  };
  specialRequests: number;
  bufferTime: number;
  increasePercentageByFrequency: number;
  cost: number;
  time: {
    minutes: number;
    formatted: string;
  };
}

interface UseGetSalesParams {
  areas: AreaByScopeOfWork[];
  typeOfService: TypeOfService;
  squareFootage: TSquareFootage;
  travelBufferTimeInGeneral?: number;
  frequencyType?: string;
  otherAreas?: any[];
  additionalObjects?: any[];
  specialRequests?: any[];
}

export const useGetSales = ({
  areas,
  typeOfService,
  squareFootage,
  travelBufferTimeInGeneral,
  frequencyType,
  otherAreas,
  additionalObjects,
  specialRequests,
}: UseGetSalesParams) => {
  return useQuery<SalesResponse>({
    queryKey: ["sales", areas, typeOfService, squareFootage, travelBufferTimeInGeneral, frequencyType],
    queryFn: async () => {
      const response = await getSales({
        areas,
        typeOfService,
        squareFootage,
        travelBufferTimeInGeneral,
        frequencyType,
        otherAreas,
        additionalObjects,
        specialRequests,
      });
      return response.data;
    },
    // Enable query if squareFootage and typeOfService exist, and costBias is defined
    // baseRatePerHour can be 0 (which is falsy but valid), so we check for !== undefined instead of truthy
    enabled: !!squareFootage && !!typeOfService && typeOfService.costBias !== undefined && typeOfService.baseRatePerHour !== undefined,
    placeholderData: (previousData) => previousData, // Keep previous data while fetching new data
    refetchOnWindowFocus: false, // Don't refetch on window focus
  });
};